import { serializePlaintext } from './serialize_plaintext';

export default function getSelectedPlaintext(editor) {
  const fragment = editor.getFragment();
  const plaintext = serializePlaintext({ children: fragment });
  return plaintext.trim();
}
